import { useAuth } from "@hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * For pre-authentication pages that you should not be able to go to after authentication
 * @param {*} auth from the useAuth hook - typically extracted at parent component level
 * @returns null
 */
export function useRedirectAuthenticatedUsers() {
  const navigate = useNavigate();
  const { isUserAuthenticated, nextPath, setNextPath } = useAuth();

  useEffect(() => {
    if (!isUserAuthenticated) {
      return;
    }

    if (nextPath) {
      setNextPath(null);
      navigate(nextPath);
    } else {
      navigate("/dashboard");
    }
  }, [isUserAuthenticated]);

  return null;
}
